import React from 'react';
import { ValidationErrors } from 'final-form';
import { Form } from 'react-final-form';

import { Page } from '@occc-app/design-system';

import { CreateUserFormRenderComponent } from './CreateUserFormRenderComponent';

import { validateUser } from '../validation';
import { UserFormProps, UserFormValues, UserFormRenderProps } from '../types';

export interface CreateUserPageProps {
  userCreate: UserFormProps['onSubmit'];
  validate?: (values: Partial<UserFormValues>) => Promise<ValidationErrors>;
}

export const CreateUserPage: React.FC<CreateUserPageProps> = ({ userCreate }) => {
  const renderForm: UserFormProps['render'] = React.useCallback(
    ({ handleSubmit, valid, submitting }: UserFormRenderProps) => {
      return (
        <CreateUserFormRenderComponent
          handleSubmit={handleSubmit}
          disabled={!valid || submitting}
        />
      );
    },
    [],
  );

  return (
    <Page
      browserTabTitle='Create User'
      pageHeaderProps={{ title: 'New User', subtitle: 'Create a new user' }}
      containerProps={{ variant: 'md' }}
    >
      <Form<UserFormValues> onSubmit={userCreate} render={renderForm} validate={validateUser} />
    </Page>
  );
};
